import React, { useState } from "react";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || `HTTP ${res.status}`);
      }
      setDone(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white/5 backdrop-blur-xl rounded-2xl p-8 shadow-lg border border-white/10">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-[#00FF99]">KweryAI</h1>
          <p className="text-gray-400 text-sm mt-1">Reset your password</p>
        </div>

        {done ? (
          <div className="space-y-4">
            <div className="rounded-lg border border-[#00FF99]/40 bg-[#00FF99]/10 px-4 py-3 text-sm text-[#00FF99]">
              If that email exists, a reset link has been sent. Check your inbox (and spam).
            </div>
            <Link
              to="/login"
              className="block w-full text-center bg-[#00FF99] text-black font-semibold p-3 rounded-xl hover:bg-[#00cc7a] transition"
            >
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} noValidate>
            <p className="text-white/60 text-sm mb-5">
              Enter the email address linked to your account and we'll send you a reset link.
            </p>

            <label className="block text-xs text-[#00FF99]/70 uppercase tracking-wider mb-1">
              Email
            </label>
            <input
              type="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full mb-4 p-3 rounded-xl bg-black/40 border border-white/20 text-white placeholder-white/30 outline-none focus:border-[#00FF99]/50 transition"
              disabled={submitting}
            />

            {error && (
              <p className="text-red-400 text-sm mb-3" role="alert">{error}</p>
            )}

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-[#00FF99] text-black font-semibold p-3 rounded-xl hover:bg-[#00cc7a] transition disabled:opacity-50"
            >
              {submitting ? "Sending…" : "Send reset link"}
            </button>

            <p className="text-center text-white/40 text-xs mt-5">
              Remembered it?{" "}
              <Link to="/login" className="text-[#00FF99] hover:underline">Back to Sign In</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
